import {
  Component,
  Input,
  ViewChild,
  forwardRef,
  ElementRef,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MyRenderer} from "@shared/inline-edit/inline-edit.service"
import {SharedService} from "@shared/shared.service";

const INLINE_EDIT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InlineEditSelectComponent),
  multi: true
};

@Component({
    selector: 'app-inline-edit-select',
    templateUrl: './inline-edit-select.component.html',
    providers: [INLINE_EDIT_CONTROL_VALUE_ACCESSOR],
    styleUrls: ['./inline-edit-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InlineEditSelectComponent implements OnInit {
  @ViewChild('inlineEditSelectControl') inlineEditSelectControl: ElementRef; // input DOM element
  @Input() labelClass;  // Label value for input element
  @Input() item;  // complete value
  @Input() key;  // Label value for input element
  @Input() formClass;  // Label value for input element
  @Input() label: string = '';  // Label value for input element
  @Input() items: any;  // Label value for input element
  @Input() multiple: boolean = false;  // The type of input element
  @Input() closeOnSelect: boolean = false; // The type of input element
  @Input() required: boolean = false; // Is input requried?
  @Input() disabled: boolean = false; // Is input disabled?
  @Input() saveData: any = Function.prototype;
  @Input() permissions: boolean;
  @Input() index: any = Number;
  private selectedValue: any// Private variable for input value
  private selectedIndex: Number // Private variable for input value
  private _value = {}; // Private variable for input value
  private preValue: string = ''; // The value before clicking to edit
  editing: boolean = false; // Is Component in edit mode?
  public onChange: any = Function.prototype; // Trascend the onChange event
  public onTouched: any = Function.prototype;
  responseMessage: any = {};

  constructor(private _renderer: MyRenderer,
              private sharedService: SharedService) {
    document.addEventListener('click', () => {
      if(this.editing==true) {
        this.showErrorMsg()
        // this.onBlur();
      }
    });
  }

  ngOnInit() {
    // console.log(this.item)
  }

  get value(): any {
    return this._value;
  }

  // currentValue(): any {
  //   return this._value;
  // }

  showErrorMsg() {
    document.getElementById("selectedId").classList.add("alerts-border");
    document.getElementById("saveDiv").classList.add("alerts-border");
    document.getElementById("rejectDiv").classList.add("alerts-border");
  }

  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.selectedIndex = this.index;
      this.onChange(v);
    }
  }

  // Required for ControlValueAccessor interface
  writeValue(value: any) {
    this._value = value;
  }

  // Required forControlValueAccessor interface
  public registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  // Required forControlValueAccessor interface
  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  // Do stuff when the input element loses focus

  onBlur() {
    if (this.permissions) {
      this.editing = false;
      if (this.index == this.selectedIndex) {
        if (this.value == undefined && this.value != null) {
          return
        } else if (this.value != this.selectedValue) {
          if (this.required == true && !this.value) {
            this.editing = true;
          } else {
            // if(!this.value.length) {
            //   this.value = null;
            // }
            this.value = {
              value: this.value,
              key: this.key
            }
            this.saveData(this.value);
          }
        }
      }
    }
  }

  // Start the editting process for the input element
  edit(e, value) {
    e.stopPropagation();
    if (this.item.editable) {
      if (this.disabled) {
        return;
      }
      var elementExists = document.getElementById("selectedId");
      if (elementExists == null) {
        if (this.value) {
          if (this.multiple == true) {
            this.selectedValue = [];
          } else {
            this.selectedValue = {};
          }
          this.selectedValue = this.value;
          this.preValue = value;
        }
        if (this.permissions) {
          this.editing = true;
          // Focus on the input element just as the editing begins
          if (this.inlineEditSelectControl) {
            setTimeout(_ => this._renderer.invokeElementMethod(this.inlineEditSelectControl,
              'click'));
          }
        }
      } else {
        this.showErrorMsg();
      }
    }
  }

  previousValue(e) {
    e.stopPropagation();
    this.value = this.selectedValue;
    this.editing = false;
  }

}
